import { render, staticRenderFns } from "./OverviewCards.vue?vue&type=template&id=281e032f"
import script from "./OverviewCards.vue?vue&type=script&lang=js"
export * from "./OverviewCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports